import { FC, HTMLAttributes } from "react";
import { useStyles } from "./FriendCard.styles";
import { Skeleton } from "../../core/Skeleton";
import clsx from "classnames";

export const FriendCardLoading: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Skeleton height={60} width={76} variant="circle" />
      <div
        className={clsx(classes.content, classes.loadingText)}
        style={{ display: "flex" }}
      >
        <Skeleton height={20} width={100} variant="text" />
        <Skeleton height={40} width={40} variant="circle" />
      </div>
    </div>
  );
};
